export default "__VITE_ASSET__3t3ctzvR__"